import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { Box, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem/MenuItem.js';
import Select, { SelectChangeEvent } from '@mui/material/Select/Select.js';

import { useMuiStyles } from '../hooks/useMuiStyles';

import { IDropdownProps } from './models/IDropdownProps';
import { IDropdownStyle } from './models/IDropdownStyle';
const isNullOrEmpty = common.commonUtils.isNullOrEmpty;

export const Dropdown: React.FC<IDropdownProps> = ({ activeIndex, handleChange, items, children, getLabel }) => {
	const styles = useMuiStyles('dropdown') as IDropdownStyle;

	const handleDropdownChange = (event: SelectChangeEvent<number>, child: React.ReactElement<any>) => {
		const childValue = child?.props?.value;
		handleChange(childValue);
	};

	return (
		<>
			<Box className={`dropdown-container`} sx={styles?.dropdownContainer?.styles}>
				<Select
					value={activeIndex}
					onChange={handleDropdownChange}
					sx={styles?.dropdownContainer?.select?.styles}
					fullWidth
				>
					{items?.map(({ tabKey, header, icon }, index) => {
						const label = (
							<Typography variant="button" sx={styles?.dropdownContainer?.select?.option?.label?.styles}>
								{getLabel(header)}
							</Typography>
						);
						const iconComponent = (
							<img
								width={20}
								aria-hidden={isNullOrEmpty(label) || true}
								src={icon.asset}
								alt={`${icon.alt} ${tabKey}`}
								style={styles?.dropdownContainer?.select?.option?.icon?.styles}
							/>
						);
						return (
							<MenuItem
								key={`menu-item-${tabKey}`}
								value={index}
								sx={styles?.dropdownContainer?.select?.option?.styles}
							>
								{icon && icon?.align === 'start' && iconComponent}
								{label}
								{icon && icon?.align === 'end' && iconComponent}
							</MenuItem>
						);
					})}
				</Select>
			</Box>
			{children}
		</>
	);
};
